module.exports = __webpack_public_path__ + "static/media/arrow-primary.04c6b94b.svg";